import styled from '@emotion/styled';

export const Container = styled.div`
	max-width: 136rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	padding-top: calc(${(props) => props.theme.heights.header} + 8rem);
	padding-bottom: 8rem;
	@media screen and (max-width: 1180px) {
		padding-top: calc(${(props) => props.theme.heights.headerMobile} + 8rem);
	}
	@media screen and (max-width: 1420px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}
`;
export const Aside = styled.aside`
	display: flex;
	flex-direction: column;
	max-width: 24rem;
	width: 100%;
	.info {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		padding: 2.4rem 2rem 1.6rem 2rem;
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
		.title {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 130%;
			letter-spacing: -0.6px;
		}
	}
`;

export const LogoutButton = styled.button`
	cursor: pointer;
	display: flex;
	align-items: center;
	background-color: transparent;
	border: none;
	color: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	height: 3.2rem;
`;
export const MenuBoxList = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0.8rem 0;
`;
export const MenuBox = styled.div`
	background-color: #f8f9fa;
	color: #868e96;
	padding: 1.6rem 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	cursor: pointer;
	&.active {
		color: ${(props) => props.theme.colors.primary400};
		border-right: 0.4rem solid ${(props) => props.theme.colors.primary400};
	}
`;
export const Main = styled.div`
	display: flex;
	gap: 4rem;
`;
export const MainContent = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;
export const Title = styled.h1`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
